import { defineStore } from 'pinia'
import { ref } from 'vue'
import client from '../api/client.js'

export const useShopStore = defineStore('shop', () => {
  const products = ref({})
  const carts = ref({})
  const serverResults = ref([])
  const importResult = ref(null)
  const shop = ref(null)
  const eligibility = ref(null)
  const shopLoading = ref(false)

  async function loadShop(shopId) {
    shopLoading.value = true
    try {
      let data
      try {
        const res = await client.get(`shops/${shopId}`)
        data = res.data
      } catch (e) {
        data = { id: shopId, name: shopId }
      }
      shop.value = data
      try {
        const res = await client.get(
          `marketplace/products/shopId/${shopId}/active`,
        )
        products.value = res.data || []
      } catch (e) {
        products.value = []
      }
      return shop.value
    } catch (e) {
      throw e
    } finally {
      shopLoading.value = false
    }
  }

  async function checkEligibility(shopId) {
    try {
      const data = await getCommunityEligibility(shopId)
      eligibility.value = data
      return data
    } catch (e) {
      eligibility.value = { eligible: false, reason: e?.message || null }
      return eligibility.value
    }
  }

  async function createShop(payload = {}) {
    const { data } = await client.post('marketplace/seller-profile', {
      sellerType: payload.sellerType || 'BUSINESS',
      businessName: payload.name || payload.businessName || '',
      displayName:
        payload.displayName || payload.name || 'My shop',
      description: payload.description || '',
      logoUrl: payload.logoUrl || '',
      location: payload.location || '',
      phone: payload.contactPhone || payload.phone || '',
      websiteUrl: payload.contactEmail || payload.websiteUrl || '',
    })
    shop.value = data
    return data
  }

  async function getProduct(productId) {
    try {
      const { data } = await client.get(`products/${productId}`)
      return data
    } catch (e) {
      throw e
    }
  }

  async function createCart(payload) {
    try {
      const { data } = await client.post(`shop-carts`, payload)
      return data
    } catch (e) {
      throw e
    }
  }

  async function addCartItem(cartId, userId, itemData) {
    try {
      const { data } = await client.post(`shop-carts/${cartId}/items`, itemData)
      return data
    } catch (e) {
      throw e
    }
  }

  async function getCart(cartId) {
    try {
      const { data } = await client.get(`shop-carts/${cartId}`)
      return data
    } catch (e) {
      throw e
    }
  }

  async function getCartItems(cartId) {
    try {
      const { data } = await client.get(`shop-carts/${cartId}/items`)
      return data
    } catch (e) {
      throw e
    }
  }

  async function getSharedCart() {
    try {
      const { data } = await client.get(`shop-carts/shared`)
      return data
    } catch (e) {
      throw e
    }
  }

  async function inviteCart(cartId, payload) {
    try {
      await client.post(`shop-carts/${cartId}/invitations`, payload)
    } catch (e) {
      throw e
    }
  }

  async function checkoutCart(cartId) {
    try {
      const { data } = await client.post(`shop-carts/${cartId}/checkout`)
      return data
    } catch (e) {
      throw e
    }
  }

  async function submitOffer(productId, payload) {
    try {
      await client.post(`products/${productId}/offers`, payload)
    } catch (e) {
      throw e
    }
  }

  async function getCommunityEligibility(shopId) {
    try {
      const { data } = await client.get(`shops/${shopId}/community/eligibility`)
      return data
    } catch (e) {
      throw e
    }
  }

  async function createCommunity(shopId, payload) {
    try {
      const { data } = await client.post(`shops/${shopId}/community`, payload)
      return data
    } catch (e) {
      throw e
    }
  }

  return {
    products,
    carts,
    serverResults,
    importResult,
    shop,
    eligibility,
    shopLoading,
    loadShop,
    checkEligibility,
    createShop,
    getProduct,
    createCart,
    addCartItem,
    getCart,
    getCartItems,
    getSharedCart,
    inviteCart,
    checkoutCart,
    submitOffer,
    getCommunityEligibility,
    createCommunity
  }
})